import React, { useEffect } from 'react';
import './index.scss';
import Icon from '../icon';

export default function Modal({
  close,
  title,
  children,
  styles,
  className = '',
  hasScroll = true,
}) {
  useEffect(() => {
    if (!hasScroll) {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = 'visible';
      };
    }
  }, [hasScroll]);
  return (
    <div
      className={`modal-wrapper ${className}`}
      style={styles}
      data-testid={'modal-wrapper'}
      data-html2canvas-ignore
    >
      <div className={'icon'} onClick={close} data-testid={'modal-close'}>
        <Icon icon={'close'} size={16} />
      </div>
      <h3 className={'zds-heading-l-highlight'}>{title}</h3>
      {children}
    </div>
  );
}
